import Image from 'app/Components/Shared/Image/image';
import React, {useEffect, useRef, useState} from 'react';
import TextInput from 'app/Components/Shared/TextInput/TextInput';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import {SendResumeData} from 'app/Components/Page/CellcomCareersPage/CellcomCareersSlice';
import {connect, useDispatch} from 'react-redux';
import BtnUnderLine from 'app/Components/Shared/Buttons/BtnUnderLine';
import whatsappIcon from '../Img/whatsappIcon.svg';
import {regexPatterns} from 'app/utilities/validation/validationVariables';
import {Input} from 'reactstrap';
import {GetTransactionSummaryData} from 'app/Components/Page/TransactionSummaryPage/TransactionSummarySlice';
import AddressFrm from 'app/Components/Shared/AddressFrm/AddressFrm';
import Autocomplete from 'app/Components/Shared/AutoCompleteInput/AutoCompleteInput';

const SendJobForm = ({
                         cities,
                         suggestCities,
                         codeJob,
                         sendJobOnWhatsapp,
                         whatsapp,
                         isResumeRequired,
                         setSubmitData,
                         title,
                         SendResumeData,
                         gtag4,
                         utilJobs,
                         listAdLocation,
                     }) => {
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [file, setFile] = useState('');
    const [fileContent, setFileContent] = useState(null); // State to store file content
    const [city, setCity] = useState('');
    const cityRef = useRef();
    const [address, setAddress] = useState({
        city: {value: '', code: '', semel: '', error: ''},
    });
    const [form, setForm] = useState({cityName: '', streetName: ''});

    const [error, setError] = useState({
        firstNameError: '',
        lastNameError: '',
        phoneNumberError: '',
        email: '',
        file: '',
        city: '',
    });
    const allowedFileTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ];

    const onChange = (type, value) => {
        checkFieldValidation(type, value);
    };

    const checkFieldValidation = (type, value) => {
        let isValid = true;
        const validName = /^[א-תA-Za-z ."״()-/\'/׳]+$/;

        switch (type) {
            case 'firstName':
                setFirstName(value);
                if (value?.trim().length < 2 || !validName.test(value)) {
                    error.firstNameError = 'שם פרטי הוא שדה חובה';
                    setError({...error});
                    isValid = false;
                } else {
                    error.firstNameError = '';
                    setError({...error});
                }
                break;
            case 'lastName':
                setLastName(value);
                if (value?.trim().length < 2 || !validName.test(value)) {
                    error.lastNameError = 'שם משפחה הוא שדה חובה';
                    setError({...error});
                    isValid = false;
                } else {
                    error.lastNameError = '';
                    setError({...error});
                }
                break;
            case 'phoneNumber':
                let isValidPhoneNumber =
                    /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(value.trim()) &&
                    /^0(5[012345678]|6[47]){1}(\-)?[^0\D]{1}\d{6}$/.test(value.trim());

                setPhoneNumber(value);

                if (!isValidPhoneNumber) {
                    error.phoneNumberError = 'טלפון הוא שדה חובה';
                    setError({...error});
                    isValid = false;
                } else {
                    error.phoneNumberError = '';
                    setError({...error});
                }
                break;
            case 'email':
                setEmail(value);
                if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)) {
                    error.email = 'אימייל הוא שדה חובה';
                    setError({...error});
                    isValid = false;
                } else {
                    error.email = '';
                    setError({...error});
                }
                break;
            case 'file':
                setFile(value); // Use value.target.files[0] to get the File object
                if (!value) {
                    // Check if the file is falsy (no file attached)
                    error.file = 'אופס הקובץ לא נתמך שננסה לסגור ל pdf ?';
                    isValid = false;
                } else if (!allowedFileTypes.includes(value.type)) {
                    error.file = 'אופס הקובץ לא נתמך שננסה לסגור ל pdf ?';
                    isValid = false;
                } else {
                    error.file = '';
                    readAndSetFileContent(value);
                }
                setError({...error});
                break;
            case 'fileSream':
                if (!value) {
                    error.file = 'אופס הקובץ לא נתמך שננסה לסגור ל pdf ?';
                    setError({...error});
                    isValid = false;
                } else {
                    error.file = '';
                    setError({...error});
                }
                break;
            case 'city':
                var selectedCity = cities.find((x) => x.cityCode === value || x.cityName === value);
                setCity(selectedCity?.cityName);

                if (!selectedCity) {
                    error.city = 'עיר הוא שדה חובה';
                    setError({...error});
                    isValid = false;
                } else {
                    error.city = '';
                    setError({...error});
                }
                break;
        }

        return isValid;
    };

    const readAndSetFileContent = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            setFileContent(e.target.result);
        };
        reader.readAsDataURL(file);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (
            !checkFieldValidation('firstName', firstName) ||
            !checkFieldValidation('lastName', lastName) ||
            !checkFieldValidation('phoneNumber', phoneNumber) ||
            !checkFieldValidation('email', email) ||
            (!checkFieldValidation('fileSream', fileContent) && isResumeRequired) ||
            !checkFieldValidation('city', city)
        ) {
            return;
        }
        try {
            const pepperData = {
                jobId: codeJob,
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: phoneNumber,
                fileName: file.name,
                fileType: file.type,
                fileStream: fileContent,
                city: city,
                sender: 'Default',
                source: 'Cellcom_Careers_Cv',
            };
            gtag4({
                event: `'CellcomJobs_CvSubmit`,
                action: 'CvSubmit',
                content: title,
                category: utilJobs,
                place: listAdLocation,
                button: event.target?.childNodes[0]?.innerText,
            });
            console.log({pepperData});
            setSubmitData({name: firstName, jobTitle: title});
            SendResumeData(pepperData);
        } catch (e) {
            return;
        }
    };
    return (
        <>
            <div className='careers-adItem__sendJob'>
                <h2>הגשת מועמדות</h2>
                <form noValidate id='clientLocation' encType='multipart/form-data' onSubmit={handleSubmit}>
                    <TextInput
                        onChange={(e) => onChange('firstName', e.target.value)}
                        value={firstName}
                        className='text-input'
                        placeholder='שם פרטי'
                        type='text'
                        autoComplete='off'
                        required='required'
                        error={error.firstNameError}
                    />

                    <TextInput
                        onChange={(e) => onChange('lastName', e.target.value)}
                        value={lastName}
                        className='text-input'
                        placeholder='שם משפחה'
                        type='text'
                        autoComplete='off'
                        required='required'
                        error={error.lastNameError}
                    />
                    <div style={{position: 'relative'}}>
                        <Autocomplete
                            injectedValue={''}
                            form={form}
                            error={address.city.error}
                            value={address.city.value}
                            id='city'
                            name='city'
                            onSelectedChange={(e) => onChange('city', e.target.value)}
                            suggestions={cities}
                            dataKey='cityCode'
                            dataValue='cityName'
                            placeholder='עיר'
                            required='required'
                        />
                    </div>
                    {error.city.length > 0 && <div className='error'> {error.city}</div>}
                    <TextInput
                        className='text-input'
                        onChange={(e) => onChange('email', e.target.value)}
                        value={email}
                        placeholder='אימייל'
                        type='text'
                        autoComplete='off'
                        required='required'
                        error={error.email}
                    />

                    <TextInput
                        className='text-input'
                        onChange={(e) => onChange('phoneNumber', e.target.value)}
                        value={phoneNumber}
                        placeholder='טלפון'
                        type='text'
                        autoComplete='off'
                        required='required'
                        maxLength='10'
                        error={error.phoneNumberError}
                    />

                    <div className={'form-control'}>
                        <label htmlFor='careers-adItem__sendJob__file-input'
                               className={`careers-adItem__sendJob__file-input__label`}>
              <span className={`${error && error.file.length > 0 ? 'placeholder-error' : ''}`}>
                {error && error.file.length > 0 ? (
                    <span className='error'>{error.file}</span>
                ) : (
                    <>
                        {file ? (
                            <>{file.name}</>
                        ) : (
                            <>
                                <span
                                    style={{fontFamily: '$ragSansSemiBold', color: '#404040'}}> צירוף קורות חיים </span>

                                {isResumeRequired && <span style={{color: 'var(--theme-primary, #9631ff)'}}> *</span>}
                            </>
                        )}
                    </>
                )}
              </span>
                        </label>

                        <input
                            onChange={(e) => onChange('file', e.target.files[0])}
                            type='file'
                            className='text-input careers-adItem__sendJob__file-input'
                            required={isResumeRequired && 'required'}
                            hidden
                            id='careers-adItem__sendJob__file-input'
                            onClick={(e) => (e.target.value = null)} // Clear the input value to allow selecting the same file again
                        />
                    </div>
                </form>

                <BtnSubmit className={'careers-adItem__sendJob__button'} text={'שליחה'} formid='jobcareers'
                           onclick={handleSubmit}/>
                <div className='careers-adItem__open-collapse__details'>
                    <p>
                        המידע שיימסר על ידך ישמש את קבוצת {window.Config.brand_Name_HE} ו/או מי מטעמה כדי לבחון את מועמדותך למשרה וכן למשרות נוספות,
                        לפעולות תפעוליות ולמטרות נוספות. לא חלה עליך חובה למסור את המידע, אך אם תבחר שלא למסרו,
                        לא ניתן יהיה לבחון את התאמתך.
                        למידע נוסף, כולל אודות המידע שנאסף והשימושים בו, למי המידע עשוי להימסר וזכויותיך לעיון ותיקון מידע אישי,
                        ראה
                        &nbsp;
                    <a href="https://contentepi.cellcom.co.il/globalassets/16/privacyLaws.pdf" target="_blank"  >מדיניות הפרטיות</a>&nbsp;
                        של {window.Config.brand_Name_HE} למועמדים לעבודה.
                    </p>
                </div>
                {whatsapp && whatsapp.length > 0 && (
                    <span className='career_job_on_whatsapp'>
            <button className={'career_job_on_whatsapp__btn-underline'} onClick={sendJobOnWhatsapp}>
              <Image src={whatsappIcon} alt={'whatsappIcon'} />
              <span className='career_job_on_whatsapp__btn-underline-text'>הגשה מהירה דרך WhatsApp</span>
            </button>
          </span>
                )}
            </div>
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        ...state,
        suggestCities: state.cities,
    };
};
const mapDispatchToProps = {
    SendResumeData,
};

export default connect(mapStateToProps, mapDispatchToProps)(SendJobForm);
